// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer___2bSLt"};